import { render, staticRenderFns } from "./ProductSalesPricePopupIframe.vue?vue&type=template&id=cd8ca340&"
import script from "./ProductSalesPricePopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPricePopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports